import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CredentialPayload, ModuleRepositoryExample, RepositoryPayload, ModuleBuilderRepository } from '../../models/repository.model';

@Injectable()
export class RepositoryService {
    private repositoryServiceUrl = '/api/module_builder/';

    constructor(private http: HttpClient) {}

    getById(id: string): Observable<ModuleBuilderRepository> {
        return this.http.get<ModuleBuilderRepository>(`${this.repositoryServiceUrl}repository/${id}`);
    }

    getModuleExamples(): Observable<ModuleRepositoryExample[]> {
        return this.http.get<ModuleRepositoryExample[]>(`${this.repositoryServiceUrl}moduleexamples`);
    }

    createRepository(payload: RepositoryPayload): Observable<RepositoryPayload> {
        return this.http.post<RepositoryPayload>(`${this.repositoryServiceUrl}repository`, payload);
    }

    setCredential(payload: CredentialPayload): Observable<CredentialPayload> {
        return this.http.post<CredentialPayload>(`${this.repositoryServiceUrl}profile`, payload);
    }

    getUserNameInfo(): Observable<{ name: string }> {
        return this.http.get<{ name: string }>(`${this.repositoryServiceUrl}profile`);
    }
}
